import React from "react";
import { Stack, Typography } from "@mui/material";

const FormHeader = ( {title} ) => {
  return (
    <Stack justifyContent={"center"} alignItems={"center"} spacing={1}>
      <Typography variant={"h4"}> {title} </Typography>
    </Stack>
  );
};

export default FormHeader;
